module.exports = __webpack_public_path__ + "img/DiferenciaHoraCCTEnActivacion.155e0b48.svg";